<template>
  <div class="sign-up-box">
    <h1>{{ title }}</h1>
    <form @submit.stop.prevent>
      <div class="org-group">
        <custom-input
          :inputType="'text'"
          v-model="info.name"
          :name="'org-name'"
          :label="$t('signup.org-label')"
          :placeholder="$t('signup.org-placeholder')"
          :focusInputField="true"
        />
      </div>
      <div class="name-group">
        <custom-input
          :inputType="'text'"
          v-model="info.user.name"
          :name="'name'"
          :label="$t('signup.name-label')"
          :placeholder="$t('signup.name-placeholder')"
        />
      </div>

      <div class="phone-group">
        <custom-input
          :inputType="'tel'"
          v-model="info.user.phone"
          :name="'Phone'"
          :label="$t('signup.phone-label')"
          :placeholder="$t('signup.phone-placeholder')"
        />
      </div>

      <div class="mail-group">
        <custom-input
          :inputType="'email'"
          v-model="info.user.username"
          :name="'email'"
          :label="$t('signup.email-label')"
          :placeholder="$t('signup.email-placeholder')"
          :invalidInput="invalidEmail"
        />
        <p v-if="invalidEmail" class="error-text-signup  small text-danger" v-html="invalidEmailMsg"></p>
      </div>

      <div class="pass-group">
        <custom-input
          :inputType="'password'"
          v-model="info.user.password"
          :name="'password'"
          :label="$t('signup.password-label')"
          :placeholder="$t('signup.password-placeholder')"
        />
        <p class="small requirements" style="margin-bottom:0;">
          {{ $t("password-validation.requirements-title") }}
          <span :class="!passwordMinLength ? 'error-text' : 'succes'">{{ $t("password-validation.chars") }}</span>
          <span :class="!passwordHasCapitalLetter ? 'error-text' : 'succes'">{{
            $t("password-validation.uppercase")
          }}</span>
          <span :class="!passwordHasNumber ? 'error-text' : 'succes'">{{ $t("password-validation.number") }}</span>
        </p>
      </div>

      <div class="rep-group">
        <custom-input
          :inputType="'password'"
          v-model="reenteredpassword"
          :name="'rep-password'"
          :label="$t('signup.repeat-label')"
          :placeholder="$t('signup.repeat-placeholder')"
        />
        <div class="small error-text" v-if="passwordsMatch == false">{{ $t("password-validation.no-match") }}</div>
      </div>

      <div class="form-group final-group">
        <div class="contact">
          <img src="@/assets/svg/Icon_Gradient.svg" />
          <div class="contact-info">
            <p>
              {{ $t("signup.help-1") }}
              <span>+45 60 51 48 36</span>
              <br />
              {{ $t("signup.help-2") }}
              <span>contact@icrobotics.com</span>
            </p>
          </div>
        </div>
        <div class="signup-btn-group">
          <div class="checkbox-group">
            <label class="container">
              <input type="checkbox" id="agree-tnc" name="agree" v-model="info.user.check" />
              <div class="check-indicator"></div>
              <label for="agree-tnc">
                {{ $t("signup.checkbox-label-1") }}
                <a target="_blank" href="https://api.icrobotics.com/static/Terms-and-Conditions.pdf"
                  >Terms &amp; Conditions</a
                >
                {{ $t("signup.checkbox-label-2") }}
                <a target="_blank" href="https://api.icrobotics.com/static/Privacy-Policy.pdf">Privacy policy</a>
              </label>
            </label>
          </div>

          <button class="btn btn-primary btn-block" type="button" :disabled="!valid || signingUp" @click="onSubmit">
            {{ btnText || $t("signup.signup-btn") }}
            <div v-if="signingUp">
              <i class="search-icon fa-light fa-circle-notch fa-spin"></i>
            </div>
          </button>
        </div>
      </div>
      <div class="small error" v-if="error">{{ $t("signup.small-error") }}</div>
    </form>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
export default {
  name: "SignUpForm",
  props: {
    btnText: {
      type: String
    },
    title: String,
    knownInfo: {
      type: Object,
      default: null
    },
    invalidEmail:{
      type: Boolean,
      default: false
    },
    invalidEmailMsg: String
  },
  data() {
    return {
      info: {
        name: "",
        user: {
          username: "",
          password: "",
          name: "",
          phone: ""
        }
      },
      reenteredpassword: "",
      error: false,
      signingUp: false,
      checkPasswordDebounce: debounce((password) => {
        this.checkPassword(password);
      }, 500),
      checkRepeatPasswordDebounce: debounce((newPassword, newPasswordRepeat) => {
        this.checkRepeatPassword(newPassword, newPasswordRepeat);
      }, 500),
      passwordLength: 0,
      passwordMinLength: false,
      passwordHasCapitalLetter: false,
      passwordHasNumber: false,
      passwordIsOk: null,
      passwordsMatch: null
    };
  },
  computed: {
    valid() {
      return (
        this.info.name &&
        this.info.user.username &&
        this.info.user.name &&
        this.info.user.phone &&
        this.info.user.check &&
        this.info.user.password == this.reenteredpassword &&
        this.passwordsMatch &&
        this.passwordIsOk
      );
    }
  },
  methods: {
    checkPassword(password) {
      // Min requirements - 6 letters, 1 capital, 1 number
      this.passwordLength = password.length;
      if (this.passwordLength >= 6) {
        this.passwordMinLength = true;
      } else this.passwordMinLength = false;
      this.passwordHasCapitalLetter = /[A-Z]/.test(password);
      this.passwordHasNumber = /\d/.test(password);
      if (this.passwordMinLength && this.passwordHasCapitalLetter && this.passwordHasNumber) {
        this.passwordIsOk = true;
      } else {
        this.info.user.password == "" ? (this.passwordIsOk = null) : (this.passwordIsOk = false);
      }
    },
    checkRepeatPassword(newPassword, repeatPassword) {
      if (repeatPassword == "") this.passwordsMatch = null;
      else {
        if (newPassword === repeatPassword) this.passwordsMatch = true;
        else this.passwordsMatch = false;
      }
    },
    onSubmit() {
      this.$emit("on-submit", this.info);

      // let data = this.info;
      // delete data.user.reenteredpassword;
      // delete data.user.check;
      // this.signingUp = true;
      // this.$store
      //   .dispatch("signUp", data)
      //   .then(() => {
      //     window.lintrk("track", { conversion_id: 6824802 });
      //   })
      //   .catch((error) => {
      //     console.log("Error", error);
      //     this.error = true;
      //     this.signingUp = false;
      //   });
    }
  },
  mounted() {
    if (this.knownInfo) {
      this.info = this.knownInfo;
    }
  },
  watch: {
    "info.user.password": function(value) {
      this.checkPasswordDebounce(this.info.user.password);
      this.checkRepeatPasswordDebounce(this.info.user.password, this.reenteredpassword);
    },
    reenteredpassword: function(value) {
      this.checkRepeatPasswordDebounce(this.info.user.password, this.reenteredpassword);
    },
    valid: {
      handler: function() {
        console.log("first")
        this.$emit("valid", this.valid);
      }
    }
  }
};
</script>

<style lang="less">
.sign-up-box {
  border-radius: var(--standard-border-radius);
  h1 {
    // margin: 40px 0 0 55px;
  }

  form {
    // padding: 0 55px 40px 55px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 4px 30px;

    .name-group {
      grid-column: 1;
    }
    .pass-group {
      grid-column: 2;
      grid-row: 2;
    }
    .rep-group {
      grid-column: 2;
      grid-row: 3;
    }
    .phone-group {
      grid-column: 1;
      // grid-row: 2;
    }
    .mail-group {
      grid-column: 2;
      grid-row: 1;
      .error-text-signup {
       margin-bottom: 0;
      }
    }

    .small {
      grid-column: 2;
    }
    label {
      font-weight: 500;
    }
    .btn-primary {
      position: relative;
      padding: 8px;
      display: flex;
      justify-content: center;
      gap: 8px;
    }
    .error {
      color: var(--danger-red);
      margin-bottom: 5px;
    }
  }

  .final-group {
    margin-top: 12px;
    grid-column-start: 1;
    grid-column-end: 3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0px 30px;
    justify-content: space-between;

    .contact {
      display: flex;
      align-self: flex-end;
      p {
        font-size: 12px;
        color: var(--charcoal-50);
        margin-bottom: 0;
        span {
          color: var(--charcoal);
        }
      }
      img {
        margin-right: 10px;
        margin-top: 3px;
        width: 35px;
        height: 35px;
      }
    }
  }

  .checkbox-group {
    label {
      font-size: 11px;
    }
    input {
      margin-left: 8px;
    }
  }

  .container {
    padding-right: 0;
    display: block;
    position: relative;
    padding-top: 2px;
    padding-left: 25px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .check-indicator {
      position: absolute;
      top: 0;
      left: 0;
      height: 20px;
      width: 20px;
      background-color: #e2e2e2;
      border-radius: 2px;

      &:after {
        content: "";
        position: absolute;
        display: none;
      }

      &:after {
        left: 7px;
        top: 3px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked ~ .check-indicator {
        background-color: var(--orange-web);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      }

      &:checked ~ .check-indicator:after {
        display: block;
      }
    }
    &:hover input ~ .check-indicator {
      filter: brightness(1.05);
    }
    label {
      margin-bottom: 0px;
    }
  }

  .error-text {
    color: #cd4b3d;
  }
  .succes {
    color: #28a745;
  }
  .requirements {
    position: absolute;
  }
}
</style>
